import app, { Component } from 'apprun';

interface IState {
    basePath: string;
}

export default class LoadingIndicatorComponent extends Component {
  state: IState = {
      basePath: ""
  };

  view = (state: IState) => <img id="loadingIndicator" className="loader hidden" src={`${state.basePath}Content/img/loader2.gif`} />;

  update = {
    '#': state => {
        const basePath = (window['defaultBasePath'] || 'http://localhost:1831/api').replace("api", "");
        return { ...state, basePath };
    }
  };
}

new LoadingIndicatorComponent().mount('loading-indicator');
